import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Question from '../../entities/question';
import Answer from '../../entities/answer';

/*
 * Delete/nullify anywhere this question is used in other entities
 *
 * @param {Question} question
 */
export function deleteQuestion(question: Question, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = question.id;
    }
    /* Simple delete usages */
        
    store.getState().answers
        .getMappingFor('questionId', question.id)
        .filter(answerTemp => answerTemp.status !== 'D')
        .forEach(answerTemp => {
            const _answer = answerTemp.clone();
            _answer.status =  'U';
            _answer.addedOn = newHRTimestamp();
            _answer.addedBy = getCurrentUserId();
            _answer.importSource = targetImportSource;
            _answer.importId = mergeId;

            _answer.questionId = '';
            store.dispatch(Actions.AnswerActions.saveAnswerQueue(_answer));
        });

    /* Remove the actual question */
    question.status = 'D';
    question.addedOn = newHRTimestamp();
    question.addedBy = getCurrentUserId();
    question.importSource = targetImportSource;
    question.importId = mergeId;
    store.dispatch(Actions.QuestionActions.removeQuestionQueue(question));
    
}

/*
 * Replace anywhere this question is used in other entities.
 *
 * @param {Question} question
 * @param {Question} replaceWith
 * @return {Question} - Question will have refs stripped away
 */
export function replaceQuestion(question: Question, replaceWith: Question, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = question.id;
    }
    /* Simple replace usages */
        
    store.getState().answers
        .getMappingFor('questionId', question.id)
        .filter(answerTemp => answerTemp.status !== 'D')
        .forEach(answerTemp => {
            const _answer = answerTemp.clone();
            _answer.status =  'U';
            _answer.addedOn = newHRTimestamp();
            _answer.addedBy = getCurrentUserId();
            _answer.importSource = targetImportSource;
            _answer.importId = mergeId;

            _answer.questionId = replaceWith.id;
            store.dispatch(Actions.AnswerActions.saveAnswerQueue(_answer));
        });

    return question;
}

/*
 * Determine the impact of deleting this question from other entities
 *
 * @param {Question} question
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactQuestion(question: Question) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const answerQuestionIdImpact = state.answers
          .getMappingFor('questionId', question.id)
          .filter(answer => answer.status !== 'D');

    answerQuestionIdImpact.forEach(() => impacts.push('answers*'));

    return util.countDistinct(impacts);
}